import { render, staticRenderFns } from "./MDKChart.vue?vue&type=template&id=f6456ef8&scoped=true&"
import script from "./MDKChart.vue?vue&type=script&lang=js&"
export * from "./MDKChart.vue?vue&type=script&lang=js&"
import style0 from "./MDKChart.vue?vue&type=style&index=0&id=f6456ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6456ef8",
  null
  
)

export default component.exports